import {
  ComponentRegister,
  ComponentRegisters,
} from '@agilelab/plugin-wb-platform-common';
import { FC } from 'react';
import { useCustomViewPreProcessor } from './propertiesProcessor';

type ComponentEntry = {
  id: string;
  function?: (props: any) => JSX.Element | JSX.Element[];
  nunjucksPropsPaths?: string[];
};

export interface CustomViewComponentRegister {
  /**
   * Register a new custom view component providing the id,
   * the rendering function, and the paths of the props that will be used as nunjucks template
   * @param entry
   */
  register(entry: ComponentEntry): void;
  get(componentId: string): Function | undefined;
  getNunjucksPropsPaths(componentId: string): string[] | undefined;
}

class DefaultCustomViewComponentRegister
  implements CustomViewComponentRegister
{
  private registry: ComponentRegister<Function>;
  constructor() {
    this.registry =
      ComponentRegisters.getComponentRegister<Function>('customView');
  }

  get(componentId: string): Function | undefined {
    return this.registry.get(componentId);
  }

  getNunjucksPropsPaths(componentId: string): string[] | undefined {
    return this.registry.getMetadata(componentId)?.nunjucksPropsPaths;
  }

  register(entry: ComponentEntry): void {
    const renderComponent = (
      props: Record<string, any>,
      componentEntry: ComponentEntry,
    ) => {
      const Component: FC = componentEntry.function as FC;
      return <Component {...props} />;
    };

    this.registry.register({
      id: entry.id,
      data: function RenderComponent(props: Record<string, any>) {
        const { props: processedProps, hidden } =
          useCustomViewPreProcessor(props);
        if (hidden) {
          return <></>;
        }
        return renderComponent(processedProps, entry);
      },
      metadata: { nunjucksPropsPaths: entry.nunjucksPropsPaths },
    });
  }
}

export const CustomViewRegister: CustomViewComponentRegister =
  new DefaultCustomViewComponentRegister();
